module.exports = __webpack_public_path__ + "static/media/preview_content_purchases.5633a074.PNG";